// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown_Vt2","select":"select_1Xp"};